<template>
  <!-- TODO: refactor component-->
  <div class="record-card-contact" :class="{ 'record-card-contact--full-height': isListView }">
    <v-card
      v-if="displayCard"
      :class="[`sc-record-card mx-auto ${cardClass}`]"
      :variant="cardVariant"
      :height="isListView ? '100%' : 'auto'"
    >
      <v-card-title v-if="showTitle">Contact</v-card-title>
      <v-divider v-if="showTitle" />
      <v-list class="pa-0">
        <v-list-item
          lines="three"
          :ripple="allowLink"
          :class="{ 'cursor-default': !allowLink }"
          class="pa-4"
          style="min-height: 80px"
          @click="handleClick()"
        >
          <v-card class="sc-record-avatar mr-3 my-0" :elevation="0" :ripple="false">
            <Upload
              v-model="showUploadPhoto"
              :options="uploadOptions"
              :source-id="item._key"
              source-type="contact"
              @fileUploaded="uploadPhoto"
            >
              <v-avatar
                v-if="showPhoto"
                class="editable-avatar"
                size="80"
                rounded="lg"
              >
                <v-img
                  v-if="!savingPhoto"
                  :src="imageUrl"
                  :class="{ 'record-card__edit-avatar': allowEdit }"
                  :cover="false"
                >
                  <template v-if="allowEdit && !item.readonly">
                    <v-icon class="record-card__icon" data-track="contact.record-card-photo.edit" @click.stop="showUploadPhoto = true">mdi-pencil</v-icon>
                    <ConfirmationDialog v-model="confirmRemoveLogoDialog" @cancel="confirmRemoveLogoDialog = false" @submit="removePhotoHandler">
                      Are you sure you want to remove photo from this record?
                    </ConfirmationDialog>
                    <v-icon class="record-card__icon" data-track="contact.record-card-photo.delete" @click.stop="confirmRemoveLogoDialog = true">mdi-trash-can-outline</v-icon>
                  </template>
                </v-img>
                <v-progress-circular
                  v-else
                  :width="3"
                  color="green"
                  indeterminate
                />
              </v-avatar>
            </Upload>
          </v-card>
          <div class="pa-0">
            <v-list-item-title class="title mb-1">
              <span class="record-id">Contact ID# {{ item._key }}</span>
              <div class="d-flex align-start">
                <div>
                  <router-link
                    v-if="allowLink"
                    :to="getAccountRoute({ name: 'contact', params: { id: item._key }})"
                    class="headline"
                    style="line-height: 24px;"
                  >
                    {{ item.first_name }} <span :style="`${source !== 'record' ? 'font-weight: 900' : ''}`">{{ item.last_name }}</span>
                    <template v-if="item.nickname">
                      ({{ item.nickname }})
                    </template>
                  </router-link>
                  <div v-else class="headline" style="line-height: 24px;">
                    {{ item.first_name }} <span :style="`${source !== 'record' ? 'font-weight: 900' : ''}`">{{ item.last_name }}</span>
                    <template v-if="item.nickname">
                      ({{ item.nickname }})
                    </template>
                  </div>
                  <div
                    v-if="item.title || (showCompany && item.company && item.company.name)"
                    class="mt-1"
                    style="font-weight: normal; font-size: 13px; text-transform: capitalize; line-height: 12px"
                  >
                    <span v-if="item.title">{{ item.title }}</span>
                    <template v-if="showCompany && item.company && item.company.name">
                      <br v-if="item.title">
                      <strong>{{ item.company.name }}</strong>
                    </template>
                  </div>
                </div>
                <div class="d-flex align-center gap-1 ml-2">
                  <a v-if="allowEdit && !item.readonly" @click.stop="editHandler">
                    <v-btn
                      size="x-small"
                      class="record-card-edit"
                      icon
                      data-track="contact.record-card.edit"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </a>
                  <router-link v-if="allowMerge" :to="getNavigationLink" class="router-link">
                    <v-btn icon size="x-small">
                      <v-icon>mdi-call-merge</v-icon>
                    </v-btn>
                  </router-link>
                  <v-btn
                    v-if="allowExport"
                    icon
                    size="x-small"
                    :loading="exportLoading"
                    data-track="contact.record-card.export"
                    @click.stop="exportContact"
                  >
                    <v-icon>mdi-file-export</v-icon>
                  </v-btn>
                </div>
                <v-checkbox
                  v-if="isListView"
                  :model-value="selected"
                  class="app-checkbox--record-card"
                  :ripple="false"
                  hide-details
                  @click.stop
                  @update:model-value="$emit('click:select', item)"
                />
              </div>
            </v-list-item-title>
            <div v-if="showCompany && !hideCompanyAddress" style="font-size: 13px;" class="mb-0">
              {{ getFormattedAddress(contactCompanyAddress) }}
            </div>
            <div v-if="useCompany" class="pl-4">
              <v-switch
                v-model="contactCompanyValue"
                :value="item._id"
                label="Use this Company for the comparable?"
                @click.stop
                @update:model-value="updateContactCompany($event)"
              />
            </div>
            <v-list-item-subtitle class="d-flex align-center flex-wrap gap-2">
              <ContactMemberChip v-if="item.is_internal" :client="item.is_client" />
              <PublishedToWebChip v-if="item.published_to_web" />
            </v-list-item-subtitle>
          </div>
          <template #append>
            <v-btn
              v-if="allowRemove"
              class="mt-2 ml-3"
              :loading="removeLoading"
              icon
              data-track="contact.record-card.remove"
              @click.stop="removeHandler"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-list-item-action v-if="allowSelect" end>
              <v-checkbox-btn
                :model-value="selected"
                :disabled="disableSelect"
              />
            </v-list-item-action>
          </template>
        </v-list-item>
      </v-list>
      <template v-if="showSummary">
        <v-divider class="mb-0" />
        <v-card-text>
          <div>
            <strong>Direct: </strong>
            <span v-if="item.phone && item.phone.direct">
              <a :href="`tel:${item.phone.direct}`">
                <span>{{ $filters.formatPhone(item.phone.direct) }}</span>
              </a>
              <span v-if="item.phone.direct_ext" class="ml-1">Ext: {{ item.phone.direct_ext }}</span>
            </span>
            <span v-else class="na">n/a</span>
          </div>
          <div>
            <strong>Mobile: </strong>
            <span v-if="item.phone && item.phone.mobile">
              <a :href="`tel:${item.phone.mobile}`">
                <span>{{ $filters.formatPhone(item.phone.mobile) }}</span>
              </a>
              <span v-if="item.phone.mobile_ext" class="ml-1">Ext: {{ item.phone.mobile_ext }}</span>
            </span>
            <span v-else class="na">n/a</span>
          </div>
          <div>
            <strong>Office: </strong>
            <span v-if="item.phone && item.phone.office">
              <a :href="`tel:${item.phone.office}`">
                <span>{{ $filters.formatPhone(item.phone.office) }}</span>
              </a> <span v-if="item.phone.office_ext">Ext: {{ item.phone.office_ext }}</span>
            </span>
            <span v-else class="na">n/a</span>
          </div>
          <div>
            <strong>Fax: </strong>
            <span v-if="item.phone && item.phone.fax">
              <a :href="`tel:${item.phone.fax}`">
                <span>{{ item.phone.fax }}</span>
              </a> <span v-if="item.phone.fax_ext">Ext: {{ item.phone.fax_ext }}</span>
            </span>
            <span v-else class="na">n/a</span>
          </div>
          <div>
            <strong>Email: </strong>
            <a v-if="item.email" :href="`mailto:${item.email}`">
              <span>{{ item.email }}</span>
            </a>
            <span v-else class="na">n/a</span>
          </div>

          <a v-if="item.linkedin_url" :href="item.linkedin_url" target="_blank">
            <v-icon color="primary">mdi-linkedin</v-icon>
          </a>
        </v-card-text>
        <v-divider />
        <v-card-text>
          <div>
            <div><strong>Office Address:</strong></div>
            <div v-if="item.office_address && item.office_address.street" class="white-space--pre-line">
              {{ getFormattedAddress(item.office_address, { includeStreet2: true }) }}
              <LocalTimeLabel :timezone="getOfficeContactAddress.timezone_name" />
            </div>
            <Label v-else />
          </div>
          <div v-if="item.home_address && item.home_address.street">
            <div><strong>Home Address:</strong></div>
            <div class="white-space--pre-line">
              {{ getFormattedAddress(item.home_address, { includeStreet2: true }) }}
            </div>
          </div>
        </v-card-text>
      </template>
    </v-card>
    <div v-else class="contact">
      <div class="contact-name">
        {{ item.first_name }} {{ item.last_name }}
      </div>
      <div v-if="item.title" class="contact-title">{{ item.title }}</div>
      <div class="contact-company">
        {{ item.company ? item.company.name : '' }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

import { ServiceFactory } from '@/services/ServiceFactory';
import { AccountLayoutMixin } from '@/bundles/App/mixins/accountMixin';
import { getFormattedAddress } from '@/bundles/App/helpers/address/getFormattedAddress';
import { usePlaceholders } from '@/bundles/App/composables/usePlaceholders';

import Upload from '@/bundles/Upload/components/Upload';
import ConfirmationDialog from '@/bundles/Common/components/ConfirmationDialog.vue';
import ContactMemberChip from '@/bundles/Contact/components/chips/ContactMemberChip.vue';
import PublishedToWebChip from '@/bundles/Contact/components/chips/PublishedToWebChip.vue';
import LocalTimeLabel from '@/bundles/App/components/labels/LocalTimeLabel.vue';
import Label from '@/bundles/Common/components/Label.vue';

const ContactService = ServiceFactory.get('contact');

export default {
  name: 'ContactCard',

  components: {
    Label,
    LocalTimeLabel,
    PublishedToWebChip,
    ContactMemberChip,
    ConfirmationDialog,
    Upload
  },

  mixins: [AccountLayoutMixin],

  props: {
    source: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: () => ({}),
    },
    cardClass: {
      type: String,
      default: '',
    },
    allowSelect: Boolean,
    disableSelect: Boolean,
    allowRemove: Boolean,
    allowMerge: Boolean,
    selected: Boolean,
    allowExport: Boolean,
    isFlat: Boolean,
    showPhoto: {
      type: Boolean,
      default: () => true,
    },
    displayCard: {
      type: Boolean,
      default: () => true,
    },
    allowPicker: Boolean,
    allowEdit: Boolean,
    showCompany: {
      type: Boolean,
      default: true,
    },
    showSummary: Boolean,
    allowLink: Boolean,
    isListView: Boolean,
    contactCompany: {
      type: String,
      default: null,
    },
    elevation: {
      type: Number,
      default: 0
    },
    showInternal: Boolean,
    showTitle: Boolean,
    useCompany: Boolean,
    removeLoading: Boolean,
    hideCompanyAddress: Boolean,
  },

  emits: ['click:select', 'editContact', 'removeHandler', 'updateContactCompany', 'updatePhoto'],

  setup () {
    const { contactPlaceholder } = usePlaceholders();

    return { contactPlaceholder };
  },

  data: () => ({
    savingPhoto: false,
    contactsFromVCF: {},
    isSelectFieldsWindowShown: false,
    exportLoading: false,
    showUploadPhoto: false,
    confirmRemoveLogoDialog: false,
  }),

  computed: {
    ...mapState({
      token: (state) => state.idToken,
    }),
    imageUrl () {
      return this.item.img || this.contactPlaceholder;
    },
    uploadOptions () {
      return { accept: 'image/*', aspectRatio: 1 };
    },
    contactCompanyValue: {
      get () {
        return this.contactCompany;
      },
      set (value) {
        this.$emit('updateContactCompany', value);
      },
    },
    getNavigationLink () {
      return this.getAccountRoute({
        name: 'contact-merge',
        params: { id: this.item._key }
      });
    },
    contactCompanyAddress: function () {
      return {
        street: this.item?.company?.address?.street || '',
        city: this.item?.company?.address?.city || '',
        state: this.item?.company?.address?.state || '',
        postal: this.item?.company?.address?.postal || '',
      };
    },
    getOfficeContactAddress: function () {
      return {
        street: this.item?.office_address?.street || '',
        street2: this.item?.office_address?.street2 || '',
        city: this.item?.office_address?.city || '',
        state: this.item?.office_address?.state || '',
        postal: this.item?.office_address?.postal || '',
        timezone_name: this.item?.office_address?.timezone_name || null,
      };
    },
    cardVariant () {
      // Outlined unless a caller asks for a flat card.
      return this.isFlat ? 'flat' : 'outlined';
    },
  },

  methods: {
    getFormattedAddress,
    ...mapMutations('Notifications', ['ADD_NOTIFICATION']),
    /**
     * Upload the photo for the contact
     */
    async uploadPhoto ({ files }) {
      this.savingPhoto = true;
      try {
        const { data } = await ContactService.updatePhoto({
          id: this.item._key,
          token: this.token,
          payload: { image: files[0] },
        });

        this.$emit('updatePhoto', data.img);
      } catch (error) {
        const notification = { ...error };
        this.ADD_NOTIFICATION(notification);
      } finally {
        this.savingPhoto = false;
        this.showUploadPhoto = false;
      }
    },
    removeHandler () {
      const payload = {
        _edge: this.item._edge,
        _key: this.item._key,
        _id: this.item._id
      };
      this.$emit('removeHandler', payload);
    },
    handleClick () {
      if (this.allowLink) {
        this.$router.push(this.getAccountRoute({ name: 'contact', params: { id: this.item._key } }));
      }
    },
    editHandler () {
      this.$emit('editContact', this.item._id);
    },
    updateContactCompany (event) {
      // this.$emit('updateContactCompany', event)
    },
    async exportContact () {
      try {
        this.exportLoading = true;
        const response = await ContactService.exportVCard({ token: this.token, id: this.item._key });

        const FileSaver = await import('file-saver');
        const file = new File([response.data], `export-${this.item.first_name}-${this.item.last_name}.vcf`);
        FileSaver.saveAs(file);
      } catch (error) {
        const notification = { ...error };
        this.ADD_NOTIFICATION(notification);
      } finally {
        this.exportLoading = false;
      }
    },
    removePhotoHandler () {
      this.uploadPhoto({ files: [null] });
      this.confirmRemoveLogoDialog = false;
    },
  },
};
</script>
<style scoped>
a.router-link {
  text-decoration: none;
}
</style>
